module.exports = __webpack_public_path__ + "media/images/focus-dimension-sample-image-thumb-5b806ad14c10bba6c8bb434ecd6768a3.jpg";